import styled from 'styled-components';
import { Button as UIKitButton } from '@landlord-tech/ui-kit-opp/dist/components/Button';

const SUIKitButton = styled(UIKitButton)`
  &&&& {
  }
`;

export default SUIKitButton;
